export const devPage = [
	{
		eyebrow: 'Skills: ReactJS, Flutter, Google Charts, Wordpress, Drupal, Sass, Css Animations, HTML5 Canvas, JavaScript6, WCAG 2.0 AA, Python, C, C++, Git, UX, UI, Web Design',
		h3: 'Web Development',
		text: 'I graduated from Oregon State University in 2022 with a degree in Computer Science.  Here is a selection of projects I worked on during my time at Oregon State.',
	},

]

export const artPage = [
	{
		eyebrow: 'Skills: PhotoShop, InDesign, Illustrator, Premiere Pro, After Effects',
		h3: 'Fine Art and Digital Media',
		text: 'I studied studio art, focusing on drawing, painting and digital media.',
	},

]

export const projPage = [
	{
		eyebrow: 'Redesign',
		h3: 'Case Study: Company Intranet',
		text: 'Sanky Tree, Line Chart, Gantt Chart, Pie Chart. Discovery Period. Take stock of intranet\'s current offerings, goals, and pain points before charting a path forward. How do People Currently use the Intranet?',
	},

]